import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-how-we-works',
  templateUrl: './how-we-works.component.html',
  styleUrls: ['./how-we-works.component.scss']
})
export class HowWeWorksComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
